module.exports = __webpack_public_path__ + "static/img/role005.277a9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role005.jpg
// module id = t9qm
// module chunks = 1